<template>
  <div class="pie_wrap">
    <div ref="chartRef" style="width: 100%; height: 320px"></div>
  </div>
</template>

<script>
import mixin from '@/page/member/mixins.js'
import echarts from '@/common/js/echarts'
import ImmersionHeader from '@/components/immersionHeader/index.vue'
const icons = {
  food: require('../../imgs/icon_food.png'),
  ride: require('../../imgs/icon_ride.png'),
  entrega: require('../../imgs/icon_entrega.png'),
  shop: require('../../imgs/icon_shop.png'),
}
export default {
  name: 'MemberDetail',
  components: {
    ImmersionHeader,
  },
  mixins: [mixin],
  props: {
    savingMoneyCount: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {
    this.initChart()
  },
  created() {},
  methods: {
    // 初始化图表
    initChart() {
      // 创建图表实例
      const myChart = echarts.init(this.$refs.chartRef)
      const style = {
        height: 16,
        width: 16,
        align: 'left',
      }
      const ligned = {
        align: 'left',
        fontSize: 14,
        fontWeight: 700,
        fontFamily: 'DiDiSans-Pro-Bold',
        color: '#ffffff',
        lineHeight: 18,
      }
      const richTextConfig = {
        Food: {
          ...style,
          backgroundColor: { image: icons.food },
        },
        Shop: {
          ...style,
          backgroundColor: { image: icons.shop },
        },
        Ride: {
          ...style,
          backgroundColor: { image: icons.ride },
        },
        Entrega: {
          ...style,
          backgroundColor: { image: icons.entrega },
        },
        paddingAligned: {
          padding: [0, 0, 0, 4],
          ...ligned,
        },
        leftAligned: {
          ...ligned,
        },
      }
      const rawData = [
        {
          value: this.savingMoneyCount.foodSavingMoney,
          name: this.$t('FoodC_bill_zfEm_MWKg'),
          iconName: 'Food',
          tranMount: this.savingMoneyCount.foodSavingMoneyTran,
        },
        {
          value: this.savingMoneyCount.shopSavingMoney,
          name: this.$t('FoodC_bill_jWTz_UdyX'),
          iconName: 'Shop',
          tranMount: this.savingMoneyCount.shopSavingMoneyTran,
        },
        {
          value: this.savingMoneyCount.rideSavingMoney,
          name: this.$t('FoodC_bill_qjez_JBnr'),
          iconName: 'Ride',
          tranMount: this.savingMoneyCount.rideSavingMoneyTran,
        },
        {
          value: this.savingMoneyCount.entregaSavingMoney,
          name: this.$t('FoodC_bill_DRvJ_yzMg'),
          iconName: 'Entrega',
          tranMount: this.savingMoneyCount.entregaSavingMoneyTran,
        },
      ]

      // 处理为0隐藏label逻辑
      const processedData = rawData.map(item => ({
        ...item,
        ...(item.value === 0
          ? {
              label: { show: false },
              labelLine: { show: false },
            }
          : {}),
      }))
      // 设置图表配置
      myChart.setOption({
        // 关闭 tooltip
        tooltip: {
          show: false,
        },
        color: ['#FFE5D9', ' #FFC9B0', '#FFAF8A ', '#FF9563'],
        // 设置系列
        series: [
          {
            // 设置类型为饼图
            type: 'pie',
            height: 320,
            left: 'center',
            bottom: 'center',
            width: '100%',
            radius: ['30%', '50%'],
            selectedMode: false,
            data: processedData,
            label: {
              formatter: function (params) {
                return `{${params.data.iconName}|}{paddingAligned|${params.name}}\n{leftAligned|${params.data.tranMount}}`
              },
              edgeDistance: 0,
              minMargin: 10,
              alignTo: 'edge',
              rich: richTextConfig,
            },
            // 设置标签线
            labelLine: {
              length: 15,
              length2: 0,
              maxSurfaceAngle: 90,
              minTurnAngle: 90,
              lineStyle: {
                color: '#ffffff',
                width: 1,
              },
            },
            // 设置强调
            emphasis: {
              scale: false,
              itemStyle: {
                shadowBlur: 0,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0)',
                color: 'inherit',
              },
            },
          },
        ],
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.pie_wrap {
  // margin-top: 15px;
}
</style>
